import { defineProperty as _defineProperty } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { __rest } from '../../_virtual/_tslib.js';
import React from 'react';
import { lsgPre } from '../../config/prefix.js';
import { cleanupClassObject } from '../../utils/DomUtils.js';
import { Host } from '../../utils/Host.js';
import { fComp } from '../../utils/React.js';
import { ActionPresentation } from '../Action/ActionPresentation.js';
import { DwindlePresentation } from '../Dwindle/DwindlePresentation.js';
import { IconPresentation } from '../Icon/IconPresentation.js';
import { hostClass } from './ActionButton.styles.js';

var defaultProps = {
  look: "primary",
  disabled: false,
  htmlAttrs: {},
  onClick: function onClick() {
    /* empty */
  },
  actionRef: function actionRef() {
    /* empty */
  },
  onMouseHoverChange: function onMouseHoverChange() {
    /* empty */
  },
  onKeyboardFocusChange: function onKeyboardFocusChange() {
    /* empty */
  }
};
// Hack: svg of the Icon is brought to the DOM for every render. This is the case after a mousedown but before a click
// event. As a consequence, the click with the old svg DOM node is not triggered. The memo hook prevents the re-render
// by making the function pure
var Icon = /*#__PURE__*/React.memo(IconPresentation);
var ActionButtonPresentation = fComp(function (props) {
  var _cleanupClassObject, _cleanupClassObject2;
  var className = props.className,
    children = props.children,
    icon = props.icon,
    iconName = props.iconName,
    iconVariant = props.iconVariant,
    look = props.look,
    disabled = props.disabled,
    noMargin = props.noMargin,
    actionRef = props.actionRef,
    hasMouseHover = props.hasMouseHover,
    hasKeyboardFocus = props.hasKeyboardFocus,
    clicked = props.clicked,
    floating = props.floating,
    loading = props.loading,
    isStencilHost = props.isStencilHost,
    horizontalAlignment = props.horizontalAlignment,
    otherProps = __rest(props, ["className", "children", "icon", "iconName", "iconVariant", "look", "disabled", "noMargin", "actionRef", "hasMouseHover", "hasKeyboardFocus", "clicked", "floating", "loading", "isStencilHost", "horizontalAlignment"]);
  var iconColor = disabled && "disabled" || look === "secondary" && "default" || "anthracite";
  return /*#__PURE__*/React.createElement(Host, {
    isStencilHost: isStencilHost,
    className: cleanupClassObject((_cleanupClassObject = {}, _defineProperty(_cleanupClassObject, hostClass, true), _defineProperty(_cleanupClassObject, className, className), _defineProperty(_cleanupClassObject, "".concat(lsgPre, "no-margin"), noMargin), _defineProperty(_cleanupClassObject, "".concat(hostClass, "__floating"), floating), _defineProperty(_cleanupClassObject, "".concat(lsgPre, "margin-align-").concat(horizontalAlignment), horizontalAlignment), _cleanupClassObject))
  }, /*#__PURE__*/React.createElement(ActionPresentation, Object.assign({
    disabled: disabled,
    loading: loading,
    ref: actionRef
  }, otherProps), /*#__PURE__*/React.createElement("div", {
    className: cleanupClassObject((_cleanupClassObject2 = {}, _defineProperty(_cleanupClassObject2, "".concat(hostClass, "-wrapper-inner"), true), _defineProperty(_cleanupClassObject2, "".concat(hostClass, "-wrapper-inner__disabled"), disabled), _cleanupClassObject2))
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(hostClass, "-dwindle-wrapper")
  }, /*#__PURE__*/React.createElement(DwindlePresentation, {
    className: cleanupClassObject(_defineProperty({}, "".concat(hostClass, "__hidden"), loading)),
    look: look,
    disabled: disabled,
    shape: "circle",
    floating: floating,
    hover: hasMouseHover || hasKeyboardFocus,
    clicked: clicked
  }, /*#__PURE__*/React.createElement(Icon, {
    noMargin: true,
    icon: icon,
    name: iconName,
    color: iconColor,
    variant: iconVariant,
    size: "small",
    "aria-hidden": true,
    title: ""
  }))), /*#__PURE__*/React.createElement("div", {
    className: "".concat(hostClass, "-label")
  }, children))));
}, defaultProps);
ActionButtonPresentation.displayName = "ActionButtonPresentation";

export { ActionButtonPresentation, defaultProps };
